/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ControlFunctionOperationalScopeDTO} from './ControlFunctionOperationalScopeDTO';

/**
 * The ControlFunctionDTO model module.
 * @module model/ControlFunctionDTO
 * @version v0
 */
export class ControlFunctionDTO {
  /**
   * Constructs a new <code>ControlFunctionDTO</code>.
   * @alias module:model/ControlFunctionDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ControlFunctionDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ControlFunctionDTO} obj Optional instance to populate.
   * @return {module:model/ControlFunctionDTO} The populated <code>ControlFunctionDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ControlFunctionDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('operationalScopes'))
        obj.operationalScopes = ApiClient.convertToType(data['operationalScopes'], [ControlFunctionOperationalScopeDTO]);
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ControlFunctionDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
ControlFunctionDTO.prototype.name = undefined;

/**
 * @member {Boolean} active
 */
ControlFunctionDTO.prototype.active = undefined;

/**
 * @member {Array.<module:model/ControlFunctionOperationalScopeDTO>} operationalScopes
 */
ControlFunctionDTO.prototype.operationalScopes = undefined;

